import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import AppUnAuth from './AppUnAuth';

import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk';

import { createDevTools } from 'redux-devtools';
import LogMonitor from 'redux-devtools-log-monitor';
import DockMonitor from 'redux-devtools-dock-monitor';
import * as reducers from './reducers';
import registerServiceWorker from './registerServiceWorker';
import { ApolloProvider } from 'react-apollo';
import ApolloClient from "apollo-boost";
import { Auth } from 'aws-amplify';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';
import * as CONFIG from './api/config';

const client = new ApolloClient({
  uri: CONFIG.ApiUrl + '/public/graphql',
  // opts: {
  //   mode: "no-cors",
  // },
  fetchOptions: {
    credentials: 'include'
  },
  request: async (operation) => {
    const jwtToken = await Auth.currentSession();
    let username = localStorage.getItem('username');
    if (!username || username === 'undefined')
      username = '';
    console.log('username=>', username);
    operation.setContext({
      headers: {
        authorization: jwtToken.idToken.jwtToken,
        'X-Api-Key': username
      }
    });
  },
  onError: ({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      // console.error(graphQLErrors);
    }
    if (networkError) {
      // console.log('Logging out users',networkError);

    }
  },
  clientState: {
    defaults: {
      isConnected: true
    },
    resolvers: {
      Mutation: {
        updateNetworkStatus: (_, { isConnected }, { cache }) => {
          cache.writeData({ data: { isConnected } });
          return null;
        }
      }
    }
  },
  cacheRedirects: {
    Query: {
      movie: (_, { id }, { getCacheKey }) =>
        getCacheKey({ __typename: 'Movie', id })
    }
  }
});

const clientUnAuth = new ApolloClient({
  uri: CONFIG.ApiUrl + '/public/graphql',
  // opts: {
  //   mode: "no-cors",
  // },
  fetchOptions: {
    credentials: 'include'
  },
  request: async (operation) => {
  },
  onError: ({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      // console.error(graphQLErrors);
    }
    if (networkError) {
      // console.log('Logging out users',networkError);

    }
  },
  clientState: {
    defaults: {
      isConnected: true
    },
    resolvers: {
      Mutation: {
        updateNetworkStatus: (_, { isConnected }, { cache }) => {
          cache.writeData({ data: { isConnected } });
          return null;
        }
      }
    }
  },
  cacheRedirects: {
    Query: {
      movie: (_, { id }, { getCacheKey }) =>
        getCacheKey({ __typename: 'Movie', id })
    }
  }
});

const reducer = combineReducers(Object.assign({}, reducers, {}));
const DevTools = createDevTools(
  <DockMonitor toggleVisibilityKey="ctrl-h"
    changePositionKey="ctrl-q">
    <LogMonitor theme="tomorrow" />
  </DockMonitor>
);

const enhancer = compose(
  // Middleware you want to use in development:
  applyMiddleware(thunkMiddleware),
  DevTools.instrument()
);

// Note: passing enhancer as the last argument requires redux@>=3.1.0
const store = createStore(reducer, enhancer);



ReactDOM.render(
  <Provider store={store}>
    <div>
      {(() => {
        if (window.location.pathname.toLowerCase() === '/qrcode/qrcodeverify') {
          return (<ApolloProvider client={clientUnAuth}  >
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <AppUnAuth />
            </MuiPickersUtilsProvider>
          </ApolloProvider>)
        } else if (window.location.pathname.toLowerCase() === '/app/paymentcancel' || window.location.pathname.toLowerCase() === '/app/paymentfailure' || window.location.pathname.toLowerCase() === '/app/paymentsuccess') {
          return (<ApolloProvider client={clientUnAuth}  >
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <AppUnAuth />
            </MuiPickersUtilsProvider>
          </ApolloProvider>)
        }
        else {
          {
            return (<ApolloProvider client={client}  >
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <App />
              </MuiPickersUtilsProvider>
            </ApolloProvider>)
          }
        }
      })()}
      {(() => {
        if (process.env.NODE_ENV === 'development1')
          return <DevTools />
      })()}
    </div>
  </Provider>,
  document.getElementById('root')
);

registerServiceWorker();


// import React from 'react';
// import ReactDOM from 'react-dom';
// import './index.css';
// import App from './App';
// import registerServiceWorker from './registerServiceWorker';

// ReactDOM.render(<App />, document.getElementById('root'));
// registerServiceWorker();
